import React from 'react';
import { theme } from './styles';

interface ScoreRingProps {
  value: number | null;
}

export const ScoreRing: React.FC<ScoreRingProps> = ({ value }) => {
  const radius = 52;
  const circumference = 2 * Math.PI * radius;
  const progress = value === null ? 0 : value / 100;

  return (
    <svg viewBox="0 0 128 128" width="136" height="136" role="img">
      <title>{value === null ? 'Carregando' : `${value} de 100`}</title>
      <circle
        cx="64"
        cy="64"
        r={radius}
        fill="none"
        stroke={theme.greenSoft}
        strokeWidth="10"
      />
      <circle
        cx="64"
        cy="64"
        r={radius}
        fill="none"
        stroke={theme.green}
        strokeWidth="10"
        strokeLinecap="round"
        strokeDasharray={`${circumference * progress} ${circumference}`}
        transform="rotate(-90 64 64)"
        style={{ transition: 'stroke-dasharray 0.4s ease' }}
      />
      <text
        x="64"
        y="62"
        textAnchor="middle"
        fontSize="34"
        fontWeight="800"
        fill={theme.text}
      >
        {value === null ? '…' : value}
      </text>
      <text x="64" y="84" textAnchor="middle" fontSize="14" fill={theme.muted}>
        /100
      </text>
    </svg>
  );
};

export interface DonutSlice {
  label: string;
  value: number;
  color: string;
}

interface DonutProps {
  slices: DonutSlice[];
  centerLabel: string;
}

export const Donut: React.FC<DonutProps> = ({ slices, centerLabel }) => {
  const radius = 44;
  const circumference = 2 * Math.PI * radius;
  const total = slices.reduce((sum, slice) => sum + slice.value, 0);

  let offset = 0;

  return (
    <svg viewBox="0 0 120 120" width="128" height="128" role="img">
      <title>{centerLabel}</title>
      <circle
        cx="60"
        cy="60"
        r={radius}
        fill="none"
        stroke={theme.border}
        strokeWidth="18"
      />
      {total > 0 &&
        slices.map(slice => {
          const length = (slice.value / total) * circumference;
          const dash = (
            <circle
              key={slice.label}
              cx="60"
              cy="60"
              r={radius}
              fill="none"
              stroke={slice.color}
              strokeWidth="18"
              strokeDasharray={`${length} ${circumference - length}`}
              strokeDashoffset={-offset}
              transform="rotate(-90 60 60)"
            />
          );
          offset += length;
          return dash;
        })}
      <text
        x="60"
        y="58"
        textAnchor="middle"
        fontSize="20"
        fontWeight="800"
        fill={theme.text}
      >
        {total}
      </text>
      <text x="60" y="74" textAnchor="middle" fontSize="9" fill={theme.muted}>
        {centerLabel}
      </text>
    </svg>
  );
};
